import { cx } from '../internal/cx';
import type { ButtonSize, ButtonVariant } from './Button';
import styles from './Button.module.css';

/**
 * Class names of a button, for elements that must be links but look like buttons (navigation
 * should use a real <a>; nesting a <button> inside an <a> is invalid and inaccessible).
 */
export function buttonClassName({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className,
}: {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  className?: string;
} = {}): string {
  return cx(styles.button, styles[variant], styles[size], fullWidth && styles.fullWidth, className);
}
